import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from 'app/components/filters/filters-panel/filter-types/types';

export class FilterCodeHierarchy extends React.Component<FilterCommonProps, {}> {

  public render() {
    const {
      filterDomain,
      optionsEndpoint,
      optionsParams,
      simpleFormComponent: SimpleForm,
      translation,
      initialValue, 
      filterDomain: { id: name },
      categoryOptionsEndpoint,
      displayCategories,
      categoryOptionsParams
    } = this.props;

    return <SimpleForm
      name={name}
      type={FIELD_TYPE.SELECT_MULTIPLE_HIERARCHY}
      initialValue={initialValue}
      optionsEndpoint={optionsEndpoint}
      categoryOptionsEndpoint={categoryOptionsEndpoint}
      placeholder={translation && this.props.translation.filters_search_placeholder}
      translation={translation}
      optionsParams={optionsParams}
      descriptionAllLevels={true}
      initiallyShowLongDescription={false}
      searchRequired={filterDomain.searchRequired}
      hasDisabledColumn={filterDomain.hasDisabledColumn}
      displayDisabledLabel={filterDomain.hasDisabledColumn && translation.include_disabled}
      displayCategories={displayCategories}
      categoryOptionsParams={categoryOptionsParams}
    />;
  }
}
